<template>
  <transition name="fade">
    <div v-if="visible" class="global-loading">
      <div class="loading-content">
        <van-loading type="circular" size="24px" color="#1989fa" />
        <span class="loading-text">Loading...</span>
      </div>
    </div>
  </transition>
</template>

<script>
import LoadingController from '../config/util/loadingController';
import { Loading } from 'vant';

export default {
  components: {
    [Loading.name]: Loading
  },
  data() {
    return {
      visible: false
    }
  },
  created() {
    LoadingController.show = () => { this.visible = true }
    LoadingController.hide = () => { this.visible = false }
  }
}
</script>

<style scoped>
/* 遮罩层 */
.global-loading {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(2px);
}

/* 内容区域 */
.loading-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px 24px;
  background: rgba(0, 0, 0, 0.7);
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

/* 加载文字 */
.loading-text {
  margin-top: 12px;
  font-size: 14px;
  color: #666;
}

/* 动画效果 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .loading-content {
    padding: 12px 20px;
  }
  .loading-text {
    font-size: 13px;
  }
}
</style>